//#region Libraries
import { Row } from "components/styles";
import styled from "styled-components";
//#endregion

export const Superheader = styled(Row)``;